export default "__VITE_ASSET__J2eLXOuI__"